import { createGetTextResources } from "../../../shared/utils/text-resources-algemeen";

export const getBerekenDateTextResources = createGetTextResources({
  ErrorDateCheckToekomstMax: `Vul een geldige datum in.`,
  ErrorDateCheckToekomstMin: `Datum moet in de toekomst liggen.`
});
